module.exports = __webpack_public_path__ + "img/1920_leuco_intro_img2.2889be60.png";